import React, {useState} from 'react'
import {Button, Form, Grid, Header, Image, Dimmer, Loader, Segment} from 'semantic-ui-react'
import img from '../../../images/logo.png'
import Axios from 'axios';
import Constants from '../../../config/constants';
import {reactLocalStorage} from 'reactjs-localstorage';
import objDefault from '../../../models/usersModel';
const LoginForm = () => {
    const [input, setInput] = useState({
        ...objDefault
    });
    const [user, setUser] = useState({});
    const handleValueChange = (e) => {
        const {
            name, value
        } = e.target;
        console.log(name, value, e)
        setInput((prevInput) => ({
            ...prevInput,
            [name]: value,
        }))
    };


    const userLogin = () =>{
        if (!input.username || !input.password) {
            alert('กรุณากรอก username และ password');
            return;
        }

        setInput((prevInput) => ({
            ...prevInput,
            userToken : 'loading'
        }));

        Axios.post('http://' + Constants.url + ':' + Constants.port + '/v1/snr/login', {
            username: input.username,
            password: input.password
        }).then(res => {
            if (res.data && res.data.code === 200 && res.data.data) {
                const userData = res.data.data;
                reactLocalStorage.set('token', userData.token);
                reactLocalStorage.set('name', userData.name + ' (' + userData.code + ')');
                reactLocalStorage.set('username', userData.username);
                
                // Fetch staff list immediately on login to cache it
                Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/staff', {
                    headers: { Authorization: userData.token }
                }).then(staffRes => {
                    if (staffRes.data && staffRes.data.code === 200 && staffRes.data.data) {
                        reactLocalStorage.set('staff_list', JSON.stringify(staffRes.data.data));
                    }
                    window.open('/home','_self');
                }).catch(err => {
                    console.log('Error fetching staff list on login:', err);
                    window.open('/home','_self');
                });
            } else {
                setInput((prevInput) => ({
                    ...prevInput,
                    userToken: ''
                }));
                alert(res.data.message || 'รหัสผ่านผิดพลาด');
            }
        }).catch(err => {
            setInput((prevInput) => ({
                ...prevInput,
                userToken: ''
            }));
            console.error(err);
            alert('เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์');
        });
    }
    return (
        <Grid textAlign='center' style={{height: '100vh'}} verticalAlign='middle'>
            <Grid.Column style={{maxWidth: 450}}>
                <Header as='h2' color='teal' textAlign='center'>
                    <Image src={img}/> Log-in to your account
                </Header>
                <Form size='large'>
                    <Segment stacked>
                        <Form.Input fluid icon='user' name='username' iconPosition='left'  value={input.username} placeholder='username'  onChange={(e)=>handleValueChange(e)}/>
                        <Form.Input
                            fluid
                            icon='lock'
                            iconPosition='left'
                            name='password'
                            value={input.password}
                            onChange={(e)=>handleValueChange(e)}
                            placeholder='Password'
                            type='password'
                        />
                        {input.userToken ?  <Dimmer active inverted >+<Loader size='medium' >Loading</Loader>+</Dimmer> : ''}

                        <Button color='teal' fluid size='large'   onClick={(e) => userLogin()}>
                            Login
                        </Button>
                    </Segment>
                </Form>

            </Grid.Column>
        </Grid>
    )
}

export default LoginForm
